export const camelToTitleCase = (camelStr: string): string => {
  // Replace the camel case boundaries with space and convert the first letter of each word to uppercase
  const result = camelStr
    .replace(/([A-Z])/g, ' $1') // Insert a space before each uppercase letter
    .toLowerCase(); // Convert the entire string to lowercase

  return result.charAt(0).toUpperCase() + result.slice(1); // Capitalize the first letter of the result
};
